import React, { useState } from 'react';
import UpdateProfilePictureModal from '../formModal/UpdateProfilePictureModal';
import imageService from '../../services/ImageService';
import { NavLink } from 'react-router-dom';

const Sidebar = ({ user}) => {
  const [showProfileModal, setShowProfileModal] = useState(false);

  return (
    <aside className="bg-dark text-light p-3" style={{ width: '250px' }}>
      {/* Profile Section */}
      <div className="text-center mb-4">
        {user?.profilePicture ? (
          <img
            src={imageService.getImage + user.profilePicture} 
            alt={user.profilePicture}
            className="rounded-circle"
            style={{ width: '80px', height: '80px', objectFit: 'cover', cursor: 'pointer'}}
            onClick={() => setShowProfileModal(true)}
          />
        ) : (
          <i className="fa fa-user fa-4x" onClick={() => setShowProfileModal(true)}
          style={{cursor: 'pointer'}}/>
        )}
        <h5 className="mt-2">{user?.name || 'User'}</h5>
        <h6 className="mt-2">{user?.designation || 'User'}</h6>
      </div>

      {/* Menu */}
      <ul className="list-unstyled">
        <li>
          <NavLink
            to="/dashboard/user-dashboard"
            className={({ isActive }) => `btn w-100 text-start mb-2 ${isActive ? 'btn-primary' : 'btn-dark'}`}
          >
            <i className="fa fa-users me-2" /> Users
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/dashboard/website-dashboard"
            className={({ isActive }) => `btn w-100 text-start mb-2 ${isActive ? 'btn-primary' : 'btn-dark'}`}
          >
            <i className="fa fa-globe me-2" /> Website
          </NavLink>
        </li>
        <li>
          <NavLink
            to="/dashboard/blog-dashboard"
            className={({ isActive }) => `btn w-100 text-start ${isActive ? 'btn-primary' : 'btn-dark'}`}
          >
            <i className="fa fa-blog me-2" /> Blogs
          </NavLink>
        </li>
      </ul>

      {/* Profile Modal */}
      {showProfileModal && (
        <UpdateProfilePictureModal
          user={user}
          onClose={() => setShowProfileModal(false)}
        />
      )}
    </aside>
  );
};

export default Sidebar;

